<div class="login-container-content prime-fg-color-3">
    <div class="registerText">
        <div *ngIf="showError">
            <span class=msg-text><b>{{errorMessage}} {{ 'requestNewConfirmationMail' | translate }}</b></span>
        </div>
        <div *ngIf="showSuccess">
            <span class=msg-text><b>{{successMessage}}</b></span>
        </div>
    </div>
    <dx-button *ngIf="showError" text="{{'sendConfirmationMail' | translate}}" type="default" [width]="'50%'" [disabled]="inProcess" (onClick)="onClickMail()"></dx-button>
    <dx-button *ngIf="showSuccess" text="{{'forRegistration' | translate}}" type="default" [width]="'auto'" (onClick)="onClickOk()"></dx-button>
</div>

